import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import PromotionalBar from './PromotionalBar';
import MobileBottomNav from './MobileBottomNav';
import FullScreenLoadingOverlay from '../Loading/FullScreenLoadingOverlay';
import { useAuth } from '../../contexts/AuthContext';
import { useCurrency } from '../../contexts/CurrencyContext';
import { useDesign } from '../../contexts/DesignContext';
import { useLoading } from '../../contexts/LoadingContext';

const BootstrapWatcher = () => {
  const { loading: authLoading } = useAuth();
  const { loading: currencyLoading } = useCurrency();
  const { loading: designLoading } = useDesign();
  const { bootstrapped, markBootstrapped } = useLoading();

  useEffect(() => {
    if (bootstrapped) return;
    // Initial site entry is considered complete once the core providers have loaded.
    // Do not block on page-level tracked requests (e.g. category fetches), otherwise
    // one slow/hanging request can keep the full-screen loader visible forever.
    if (!authLoading && !currencyLoading && !designLoading) {
      markBootstrapped();
    }
  }, [bootstrapped, authLoading, currencyLoading, designLoading, markBootstrapped]);

  return null;
};

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <BootstrapWatcher />
      <FullScreenLoadingOverlay />
      <PromotionalBar />
      <Header />
      <main className="flex-grow pb-16 md:pb-0">
        {children}
      </main>
      <Footer />
      <MobileBottomNav />
    </div>
  );
};

export default Layout;
